import * as fromDatatype from '../datatype-library';

export interface bl_fi_item_label_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    label_category_group_code: fromDatatype.VarcharDatatypeInterface;
    label_list_guid: fromDatatype.GuidDataFieldInterface;
    label_list_guid_validate_error: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    label_category_code: fromDatatype.VarcharDatatypeInterface;
    label_category_code_validate_error: fromDatatype.VarcharDatatypeInterface;
    label_category_name:fromDatatype.VarcharDatatypeInterface;
    label_category_desc: fromDatatype.VarcharDatatypeInterface;
    item_label_guid: fromDatatype.GuidDataFieldInterface;
    short_error_message: fromDatatype.VarcharDatatypeInterface;
    error_stack_trace: fromDatatype.VarcharDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_item_label_import_file_helper_RowClass implements bl_fi_item_label_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    label_category_group_code: fromDatatype.VarcharDatatypeInterface;
    label_list_guid: fromDatatype.GuidDataFieldInterface;
    label_list_guid_validate_error: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    label_category_code: fromDatatype.VarcharDatatypeInterface;
    label_category_code_validate_error: fromDatatype.VarcharDatatypeInterface;
    label_category_name:fromDatatype.VarcharDatatypeInterface;
    label_category_desc: fromDatatype.VarcharDatatypeInterface;
    item_label_guid: fromDatatype.GuidDataFieldInterface;
    short_error_message: fromDatatype.VarcharDatatypeInterface;
    error_stack_trace: fromDatatype.VarcharDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}